import React, { Fragment, useState, useContext, useEffect } from "react";
import Map from "../../Maps/map";
import { mapJson } from "./cardJson";
import { EmbarqueSumary } from "./cardSumary";
import { TablesMock } from "./tablesJson";
import { ShipmentDetail } from "./shipmentDetail";
import TablesData from "../../Table/tableContainer";
import TablePaquete from "../../Table/tableData";
import { Events } from "./events";
import { GlobalContext } from "../../../context/GlobalState";
import Loader from "../../Loader";
import { ShipmentRepository } from "../../../repositories";
export const GetMap = () => {
  const { resultList } = useContext(GlobalContext);

  const [markers, setMarkers] = useState([]);
  // const [dataMap, setDataMap] = useState([]);
  const [polylineData, setPolylineData] = useState([]);
  const [cardEmbarque, setCardEmbarque] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [allSteps, setAllSteps] = useState([]);
  const [load, setLoad] = useState(false);

  const headers = { title: "Shipment", logo: "" };


  async function EventData() {
    // let url = `${Services.Shipments.path}trazabilidad/shipmentevents/${resultList[0].ShipmentId}?lang=EN`
    // let getAllDataEvents = await Axios.get(url);
    const getAllDataEvents = await ShipmentRepository.getEvents(resultList[0].ShipmentId);

    let update = false;
    for (
      let index = getAllDataEvents.steps.length;
      index >= 0;
      index--
    ) {
      const element = getAllDataEvents.steps[index];
      if (element && element.completed) update = true;
      if (update) element.completed = true;
    }
    var newSteps = TablesMock.steps;
    let dataEvents = getAllDataEvents.data;
    var findNext = false;
    newSteps.map((f) => {
      dataEvents.map((e) => {
        if (e.EventDescriptionId === f.id) {
          findNext = true;
          f.value = e.EventDate;
          if (e.InTimeLine === "1") {
            f.completed = true;
          } else {
            findNext = false;
          }
        } else {
          findNext = false;
        }
        if (findNext) {
          f.completed = true;
        }
        return e;
      });
      return f;
    });
    newSteps.sort(function (a, b) {
      return b.order - a.order;
    });
    let findTrue = false;
    newSteps.map((e) => {
      if (e.completed) {
        findTrue = true;
      }
      if (findTrue) {
        e.completed = true;
      }
      return e;
    });
    newSteps.sort(function (a, b) {
      return a.order - b.order;
    });

    newSteps.sort(function (a, b) {
      return a.order - b.order;
    });

    setAllSteps(dataEvents);
  }



  useEffect(() => {
    if (resultList.length !== 0) {
      // let url = `${Services.Shipments.path}trazabilidad/dataShipments/${resultList[0].ShipmentId}?user=1&lang=EN`

      ShipmentRepository.getShipment(resultList[0].ShipmentId).then((success) => {
        let str = success.data.infoEmbarque.ShipmentType;
        // success.data.data.Aduanas.map((e) => {
        //   e.TotalCIF = `$${Number(e.TotalCIF).toLocaleString("de-DE")}`;
        //   return e;
        // });
        let isContenedor = false;
        if (
          str.search("FCL") > -1 &&
          success.data.infoEmbarque.TransportMode === "Sea"
        ) {
          isContenedor = true;
        } else {
          isContenedor = false;
        }
        let markers = [];
        let polylineData = [];
        if (
          success.data.infoEmbarque.POLLatitude &&
          success.data.infoEmbarque.POLLongitude
        ) {
          let obj = {
            anchorX: 20,
            anchorY: 20,
            key: 1,
            title: "Origen",
            data: success.data.infoEmbarque,
            position: {
              lat: success.data.infoEmbarque.POLLatitude,
              lng: success.data.infoEmbarque.POLLongitude,
            },
            icon: {
              url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png"
            },
          };
          let position = {
            lat: Number(success.data.infoEmbarque.POLLatitude),
            lng: Number(success.data.infoEmbarque.POLLongitude),
          };
          polylineData.push(position);
          markers.push(obj);
        }
        if (
          success.data.infoEmbarque.PODLatitude &&
          success.data.infoEmbarque.PODLongitude
        ) {
          let obj = {
            anchorX: 20,
            anchorY: 20,
            key: 2,
            data: success.data.infoEmbarque,
            title: "Destino",
            position: {
              lat: success.data.infoEmbarque.PODLatitude,
              lng: success.data.infoEmbarque.PODLongitude,
            },
            icon: {
              url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png",
            },
          };

          let position = {
            lat: Number(success.data.infoEmbarque.PODLatitude),
            lng: Number(success.data.infoEmbarque.PODLongitude),
          };
          polylineData.push(position);
          markers.push(obj);
        }

        setMarkers(markers);
        // setDataMap(polylineData);
        setPolylineData(polylineData);

        let Info = [];

        let newResume = mapJson.cardResumen.map((f) => {
          f.data.map((g) => {
            g.value = success.data.infoEmbarque[g.key];
            return g;
          });
          return f;
        });

        Info.push(success.data.infoEmbarque);
        setCardEmbarque(newResume);

        let netTabla = (isContenedor
          ? TablesMock.Table1
          : TablesMock.tables2
        ).map((f) => {
          f.data =
            success.data[f.key] && success.data[f.key].length > 0
              ? success.data[f.key]
              : [success.data.infoEmbarque];
          return f;
        });

        setTableData(netTabla);
        setLoad(true)
      })
        .catch((error) => {
          console.warn(error);
        });

      EventData();

    }

    // eslint-disable-next-line
  }, [resultList]);

  return (
    <Fragment>
      <Loader hidden={load} />
      <div id="EmbarqueDetail_MAP" className="mt-5 row">
        <div className="col-12 mb-5">
          <ShipmentDetail shipment={resultList} />
        </div>
        <div className="col-6 mb-5">
          <EmbarqueSumary headers={headers} data={cardEmbarque} />
        </div>
        <div className="col-6 mb-5">
          <Map
            heidIcon={20}
            style={{ maxHeight: "300px" }}
            marker={markers}
            visible={true}
            type={"polyline"}
            data={polylineData}
            dataDrawer={""}
          />
        </div>
        <div className="col-12 mb-5">
          {/* <div className="col-12"> */}
          {tableData.map((e, index) => {
            if (e.title === "Contenedores") {
              return (
                <TablesData
                  columns={e.columns}
                  data={e.data}
                  key={index}
                  itemsByPage={10}
                  title={e.title}
                  options={{
                    pagination: false,
                    search: false,
                    downloads: {
                      xlsx: false,
                      pdf: false,
                    },
                  }}
                />
              );
            } else {
              return (
                <TablePaquete
                  columns={e.columns}
                  data={e.data}
                  key={index}
                  itemsByPage={10}
                  title={e.title}
                  options={{
                    pagination: false,
                    search: false,
                    downloads: {
                      xlsx: false,
                      pdf: false,
                    },
                  }}
                />
              );
            }
          })}
          {/* </div> */}
        </div>
      </div>

      {/* ============================== TABLA DE EVENTOS ============================== */}
      <div className="row" id="LISTA_DE_EVENTOS">
        <div className="col-12">
          <Events allSteps={allSteps} />
        </div>
      </div>
      {/* </div> */}
    </Fragment>
  );
};
